$(function(){
  $(".list-logo-carousel").infiniteslide({
    direction:"left",
    clone:10
  });
});
$(function(){
  $(".product-logo-list").infiniteslide({
    direction:"left",
    clone:10
  });
});

$(document).ready(function(){
  $('.btn-play ').click(function() {
    var video_url = $(this).parents('.video-wrapper').data('video');
    $('.video-content').append(`<video playsinline="playsinline" autoplay="autoplay" loop="loop" controls="controls" preload="metadata"><source src="${video_url}" type="video/mp4"></video>`);
    $('html').addClass('mm-open');
    $('.popup-wrapper video').trigger('play');
  });
  $('.contact-watch ').click(function() {
    var video_url = $(this).data('video');
    $('.video-content').append(`<video playsinline="playsinline" autoplay="autoplay" loop="loop" controls="controls" preload="metadata"><source src="${video_url}" type="video/mp4"></video>`);
    $('html').addClass('mm-open');
    $('.popup-wrapper video').trigger('play');
  });
  $('.close-btn').click(function () {
    $('html').removeClass('mm-open');
    $('.video-content').empty();
  });
  $('.popup_bg').click(function () {
    $('html').removeClass('mm-open');
    $('.video-content').empty();
  });
});

function separateReviewCount() {
  // Select the element by its class within the specific structure
  const element = document.querySelector('.wholescale-review-widget-stars-injection .review-count');
  
  if (element) {
    // Get the full text
    const fullText = element.textContent.trim();
    
    // Use a regular expression to separate the number from "Reviews"
    const match = fullText.match(/(\d+)\s*(Reviews)/i);
    
    if (match) {
      const [, number, word] = match;
      
      // Create new elements for the number and the word
      const numberSpan = document.createElement('span');
      numberSpan.textContent = number;
      numberSpan.className = 'review-number';
      
      const wordSpan = document.createElement('span');
      wordSpan.textContent = word;
      wordSpan.className = 'review-word';
      
      // Clear the original content and add the new elements
      element.textContent = '';
      element.appendChild(numberSpan);
      element.appendChild(document.createTextNode(' ')); // Space between number and word
      element.appendChild(wordSpan);
    }
  }
}

function checkAndSeparate() {
  const element = document.querySelector('.wholescale-review-widget-stars-injection .review-count');
  if (element) {
    separateReviewCount();
    // If found and processed, stop the observer
    if (observer) {
      observer.disconnect();
    }
  }
}

// Set up a MutationObserver to watch for changes in the DOM
const observer = new MutationObserver((mutations) => {
  for (let mutation of mutations) {
    if (mutation.type === 'childList') {
      checkAndSeparate();
    }
  }
});

// Start observing the document with the configured parameters
observer.observe(document.body, { childList: true, subtree: true });

// Also try to run it once the DOM is initially loaded
document.addEventListener('DOMContentLoaded', checkAndSeparate);